module.exports = __webpack_public_path__ + "img/text.4c3d80cc.png";